/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export enum REGIONS {
  AQ = 'AQ',
  AT = 'AT',
  CA = 'CA',
  CH = 'CH',
  CZ = 'CZ',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  GB = 'GB',
  ID = 'ID',
  JP = 'JP',
  KR = 'KR',
  MY = 'MY',
  NL = 'NL',
  NZ = 'NZ',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  SG = 'SG',
  TH = 'TH',
  TW = 'TW',
  US = 'US',
  ZA = 'ZA',
}

export enum LANGUAGES {
  ca = 'ca',
  cs = 'cs',
  de = 'de',
  en = 'en',
  es = 'es',
  eu = 'eu',
  fr = 'fr',
  gl = 'gl',
  hak = 'hak',
  id = 'id',
  it = 'it',
  ja = 'ja',
  jv = 'jv',
  ko = 'ko',
  ml = 'ml',
  ms = 'ms',
  nan = 'nan',
  nl = 'nl',
  pa = 'pa',
  pl = 'pl',
  pt = 'pt',
  ro = 'ro',
  ta = 'ta',
  te = 'te',
  th = 'th',
  zh = 'zh',
}

export enum LOCALES {
  ca_es = 'ca-ES',
  cs_cz = 'cs-CZ',
  de_aq = 'de-AQ',
  de_at = 'de-AT',
  de_ch = 'de-CH',
  de_de = 'de-DE',
  en_aq = 'en-AQ',
  en_at = 'en-AT',
  en_ca = 'en-CA',
  en_ch = 'en-CH',
  en_cz = 'en-CZ',
  en_de = 'en-DE',
  en_es = 'en-ES',
  en_fr = 'en-FR',
  en_gb = 'en-GB',
  en_id = 'en-ID',
  en_ja = 'en-JA',
  en_kr = 'en-KR',
  en_my = 'en-MY',
  en_nl = 'en-NL',
  en_nz = 'en-NZ',
  en_pl = 'en-PL',
  en_pt = 'en-PT',
  en_ro = 'en-RO',
  en_sg = 'en-SG',
  en_th = 'en-TH',
  en_tw = 'en-TW',
  en_us = 'en-US',
  en_za = 'en-ZA',
  es_aq = 'es-AQ',
  es_es = 'es-ES',
  es_pt = 'es-PT',
  eu_es = 'eu-ES',
  fr_aq = 'fr-AQ',
  fr_ca = 'fr-CA',
  fr_ch = 'fr-CH',
  fr_fr = 'fr-FR',
  gl_es = 'gl-ES',
  hak_tw = 'hak-TW',
  id_id = 'id-ID',
  it_aq = 'it-AQ',
  it_ch = 'it-CH',
  ja_ja = 'ja-JA',
  jv_id = 'jv-ID',
  ko_kr = 'ko-KR',
  ml_my = 'ml-MY',
  ms_my = 'ms-MY',
  ms_sg = 'ms-SG',
  nan_tw = 'nan-TW',
  nl_id = 'nl-ID',
  nl_nl = 'nl-NL',
  pa_my = 'pa-MY',
  pl_pl = 'pl-PL',
  pt_es = 'pt-ES',
  pt_pt = 'pt-PT',
  ro_ro = 'ro-RO',
  ta_my = 'ta-MY',
  ta_sg = 'ta-SG',
  te_my = 'te-MY',
  th_my = 'th-MY',
  th_th = 'th-TH',
  zh_my = 'zh-MY',
  zh_sg = 'zh-SG',
  zh_tw = 'zh-TW',
}

export type LocaleData = {
  code: LOCALES;
  region: REGIONS;
  language: LANGUAGES;
};
